import React, { useEffect } from 'react';
import LegalSidebar from '../components/LegalSidebar';
import { setPageSEO } from '../utils/seo.js';
import './Terms.css';

function TermsAndCondition() {
  useEffect(() => setPageSEO({
    title: 'Terms & Conditions - Clientalio',
    description: "Read Clientalio's terms and conditions regarding services, accounts, subscriptions, and platform usage.",
    canonical: 'https://clientalio.com/terms-and-condition',
    ogTitle: 'Terms & Conditions - Clientalio',
    ogDescription: "Read Clientalio's terms and conditions regarding services, accounts, subscriptions, and platform usage.",
    twitterTitle: 'Terms & Conditions - Clientalio',
    twitterDescription: "Read Clientalio's terms and conditions regarding services, accounts, subscriptions, and platform usage."
  }), []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last Updated: 10-Sep-2024</p>
        </div>
        <div className="terms-layout">
          <LegalSidebar activePage="terms-and-condition" />

          {/* Main Content */}
          <div className="terms-content">
            <div className="content-section">

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  This page, along with our Privacy Policy and Website Terms of Use, outlines the
                  legal terms and conditions under which Clientalio makes available its online
                  testimonial collection and management platform (the "Service"). By creating an
                  account, accessing, or using our Service in any manner, you agree to be bound by
                  these Terms. If you do not agree, please discontinue use immediately.
                </p>
              </section>

              <section className="terms-section">
                <h2>2. Information About Us</h2>
                <p>
                  Clientalio ("the Platform"), owned and operated by BWays Techno Solution ("we",
                  "our", "us") operates the website clientalio.com. We are registered sole
                  proprietorship in Delhi, India.
                </p>
                <p>
                  Registered Office: Rohini, New Delhi, India<br />
                  Contact Email: <a href="mailto:support@clientalio.com">support@clientalio.com</a>
                </p>
              </section>

              <section className="terms-section">
                <h2>3. Our Services</h2>
                <p>
                  Clientalio provides tools that enable users to collect video, text, and image
                  testimonials, embed testimonials on websites, manage and showcase reviews, and
                  sync testimonials with third-party CRMs or marketing tools via integrations.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Payments & Subscriptions</h2>
                <p>
                  We offer free and paid subscription plans. Paid plans provide additional
                  features such as custom branding, HD video, CRM sync, and priority support. Payments
                  are processed securely through authorized payment partners and are shown in INR
                  (₹) where applicable.
                </p>
              </section>

              <section className="terms-section">
                <h2>5. Data Privacy & GDPR Compliance</h2>
                <p>
                  Clientalio is fully committed to data protection and GDPR compliance. When you
                  use our platform to collect testimonials, you act as the Data Controller, and
                  Clientalio acts as the Data Processor. We only process your data as necessary to
                  provide the Service and will not send marketing emails to your clients or
                  sell/share their data.
                </p>
              </section>

              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndCondition;
